import React, { useRef } from 'react';
import { observer, useAsObservableSource } from 'mobx-react-lite';
import { useAppStateContext } from '../../../AppState/AppState';
import {
    ContentContainer,
    TrashIconWrapper,
    Row,
    PromoCode,
    UsageInfo,
    PromoInfoWrapper,
} from './PromoCodesItem.style';
import moment from 'moment';
import { computed, observable, makeAutoObservable } from 'mobx';
import { PromoCodeElementType, PromoCodesState } from 'src/AppState/PromoCodesState/PromoCodesState';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import { ListItem } from 'src/domains/layouts/shared/cms/list/List.style';
import { StatusLabel } from 'src/domains/layouts/shared/labels/StatusLabel';

interface PromoCodePropsType {
    promoCode: PromoCodeElementType;
}
class State {
    @observable copySuccess = false;
    @observable isShowImages = false;
    constructor(
        private readonly promoCodeState: PromoCodesState,
        private readonly promoCode: PromoCodeElementType,
        public readonly textAreaRef: React.RefObject<HTMLTextAreaElement>
    ) {
        makeAutoObservable(this);
    }

    @computed public get isInactive(): boolean {
        const startDate = moment(this.promoCode.date_from);
        const endDate = moment(this.promoCode.date_to);
        const currentDate = moment();
        const isDateAfter = moment(startDate).isAfter(currentDate);
        const isDateBefore = moment(endDate).isBefore(currentDate);

        return isDateAfter || isDateBefore;
    }

    onToggleShowImages = (): void => {
        this.isShowImages = !this.isShowImages;
    };

    onChangePromoCodeToEdit = (): void => {
        this.promoCodeState.setPage('edit');
        this.promoCodeState.setEditedPromoCode(this.promoCode);
    };

    onRemove = (): void => {
        this.promoCodeState.onRemove(this.promoCode);
    };
}

export const PromoCodesListItem = observer(({ promoCode }: PromoCodePropsType) => {
    const { promoCodesState } = useAppStateContext();
    const promoCodeObservable = useAsObservableSource(promoCode);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const [state] = React.useState(() => new State(promoCodesState, promoCodeObservable, textAreaRef));
    const isEdited = promoCode.promo_code.code === promoCodesState.editedCode;

    return (
        <ListItem
            isEdited={isEdited}
            homepage={false}
            direction='row'
        >
            <ContentContainer>
                <PromoInfoWrapper>
                    <PromoCode>{promoCode.promo_code.code}</PromoCode>
                    <UsageInfo>Used {promoCode.promo_code.used} time(s)</UsageInfo>
                </PromoInfoWrapper>
                <Row>
                    <StatusLabel status={state.isInactive ? 'ended' : 'live'}>
                        {state.isInactive ? 'Inactive' : 'Active'}
                    </StatusLabel>
                    <Button
                        version='secondary'
                        size='small'
                        onClick={state.onChangePromoCodeToEdit}
                    >
                        Edit
                    </Button>
                    <TrashIconWrapper onClick={state.onRemove} />
                </Row>
            </ContentContainer>
        </ListItem>
    );
});
